@if (!disabled) {
  <div class="wrapper">
    <div class="contentOptions">
      <div class="search" (click)="show = true">
        @if (!app.field.isMultiple(field)) {
          <div>
            <input
              type="text"
              class="w-100 optionsInput"
              (click)="showOptions(true)"
              [(ngModel)]="search"
              [placeholder]="getPlaceholder(field)"
              />
          </div>
        }
        @if (search != '' ) {
          <span class="m-0">
            <button class="btn clearButton" (click)="clearModel()">
              <i class="fas fa-times-circle clearIcon"></i> {{app.text.import.clear}}
            </button>
          </span>
        }
        @if (!isMandatory() && search == '') {
          <span class="searchIcon">
            <i class="fa fa-search"></i>
          </span>
        }
        @if (app.field.isMultiple(field) && !show) {
          <div>
            <input
              type="text"
              class="w-100 searchInput"
              (click)="showOptions(true)"
              />
            @for (option of model[field]; track option) {
              <small
                class="badge selected m-1"
                (click)="toggleOption(field, option, model); show = false"
                >
                {{ app.users.getOptionName(option) }}
                &nbsp;
                <i class="fa fa-times"></i>
              </small>
            }
          </div>
        }
        @if (isMandatory()) {
          <span class="invalidspan"
            ><i
            class="fal fa-exclamation-circle"
            tooltipClass="customTooltip"
            [ngbTooltip]="app.text.field.requiredIcon"
            ></i
          ></span>
        }
      </div>
    </div>
    @if (show) {
      <div style="max-height: 250px; overflow-y: scroll">
        <!-- selected options if the field is type multiple -->
        @if (app.field.isMultiple(field)) {
          <button
            class="btn"
            type="button"
            (click)="show = false"
            >
            <i class="fa fa-times"></i>
            {{ app.text.user.closeBtn }}
          </button>
        }
        @for (option of app.field.getUserOptions(field); track option; let i = $index) {
          <div>
            @if (isMatch(search, option.name) && !app.field.isMultiple(field)) {
              <button
                class="btn btn-sm optionsName"
        (click)="
          $event.stopPropagation();
          toggleOption(field, option, model);
          selected.next(option)
        "
                >
                {{ option.name }}
              </button>
            }
            @if (app.field.isMultiple(field)) {
              <div>
                <button
                  class="btn btn-sm"
          (click)="
            $event.stopPropagation();
            toggleOption(field, option, model);
            selected.next(option)
          "
                  >
                  @if (app.field.isMultiple(field) && app.filterList.field == null) {
                    <input
                      type="checkbox"
                      [checked]="app.field.isOptionSelected(field, option.id, model)"
                      />
                  }
                  {{ option.name }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (model[field] != null && disabled && !app.field.isMultiple(field)) {
  <div
    class="m-1"
    >
    {{ app.users.getOptionName(model[field]) }}
    <!-- DISPLAYED ONLY FOR DB -->
    @if (getFieldType(field, model[field]) === 'responsible') {
      <button
        class="btn responsible-bullet"
        [ngbTooltip]="app.text.impact.wfResponsible"
        >
        @if (
          app.impact.displayBullet(field, red) &&
          model[field] !== '' &&
          app.unlockedId !== app.thread.id
          ) {
          <i
            class="fad fa-user-times"
          ></i>
        }
        @if (
          app.impact.displayBullet(app.fieldId.thread.dinCodeRespName, red) &&
          field === app.fieldId.thread.deputy &&
          model[app.fieldId.thread.deputy] !== '' &&
          app.unlockedId !== app.thread.id
          ) {
          <i
            class="fad fa-user-times fa-deputy"
            >
          </i>
        }
      </button>
    }
  </div>
}
@if (
  model[field] != null &&
  disabled &&
  app.field.isMultiple(field) &&
  app.unlockedId == null
  ) {
  <div
    >
    @for (option of model[field]; track option) {
      <span>
        {{ app.users.getOptionName(option) }}
      </span>
    }
  </div>
}
<!-- USED FOR PREPOPULATION OF SOME FIELDS (IMPACT CREATION - DB) -->
<!-- hidden when the value is already displayed in the input or in the read-only view -->
@if (
  app.state.createMode &&
  !disabled &&
  search !== app.users.getOptionName(model[field])
  ) {
  <div>
    <span>
      {{ app.users.getOptionName(model[field]) }}
    </span>
  </div>
}
